import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.core');

    core.constant(
        'I18N',
        Object.freeze({
            locales: {
                fallbackLanguage: ['fr'],
                availableLanguage: ['fr'],
            },
            language: [{ id: 'fr', label: 'lang.fr' }],
            country: [{ id: 'FR', label: 'country.fr' }],
        })
    );

    core.constant(
        'EMAIL_REGEXP',
        /^(?:(([A-Za-z0-9À-ÖØ-öø-ÿ!#$%&\\'*+/=?^_`{|}~-]+)\.?)*[A-Za-z0-9À-ÖØ-öø-ÿ!#$%&\\'*+/=?^_`{|}~-]+)@[a-zA-Z0-9À-ÖØ-öø-ÿ-]+(?:\.[a-zA-Z0-9-]+)*$/
    );

    core.constant(
        'DOMAIN_NAME_REGEX',
        /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/
    );

    core.constant(
        'CONF',
        Object.freeze({
            appContext: '/kiss-boclient',
            apiContext: '/kiss-boweb',
            pslEmreContext: '/emre',
            pslMetiersContext: '/metiers',
            apiBaseUrl: '/api',
            apiBoBaseUrl: '/api-bo',
            proxyEpdf: '/proxy-epdf',
            proxyZeDoc: '/proxy-zedoc',
            proxyPrePasrel: '/proxy-prepasrel',
            proxyDocRepo: '/docrepo',
        })
    );

    core.constant('XSRF_TOKEN', 'XSRF-TOKEN');

    core.constant(
        'DEMAT_PLATFORMS',
        Object.freeze({
            GIS: 'gis',
            PASREL: 'pasrel'
        })
    );

    core.constant(
        'PLATFORM_PATHS',
        Object.freeze({
            E_INVOICING : {
                GIS_OR_PASREL_DEFAULT_FOLDER : 'e_invoicing',
                PASREL_FULL_DEFAULT_PATH: 'e_invoicing'
            },
            FACTURE_X : {
                GIS_OR_PASREL_DEFAULT_FOLDER : 'FacturX',
            }
        })
    );
})();
